export * from './readonly-texte-dialog';